/* eslint-disable */
import React, { useState, useEffect } from "react";
import BossDialog from "../../../components/BossDialog";
import { Grid, GridColumn as Column } from "@progress/kendo-react-grid";
import { DropDownList } from "@progress/kendo-react-dropdowns";
import { TimePickerWithFormat } from "../../../framework/forms/helpercomponents/timepicker/TimePickerWithFormat";
import SaveButton from "../../../framework/forms/helpercomponents/buttons/SaveButton";
import CancelButton from "../../../framework/forms/helpercomponents/buttons/CancelButton";
import * as API from "../../../framework/API/api";
import { ENTITYNAME, TOAST_TYPES } from "../../../framework/constant/constant";
import { utility } from "../../../framework/utility/utilityProvider";
import ToastNotification from "../../../components/ToastNotification";
import moment from "moment";

export const MultiLiveMatchEditDialog = ({ open, items, onClose, onSaveSuccess }) => {
    const [rows, setRows] = useState([]);
    const [rounds, setRounds] = useState([]);
    const [matchTypes, setMatchTypes] = useState([]);
    const [tournaments, setTournaments] = useState([]);
    const [isSaving, setIsSaving] = useState(false);

    useEffect(() => {
        if (open) {
            loadLookupsAndInit();
        }
    }, [open, items]);

    const loadLookupsAndInit = async () => {
        const roundRes = await API.getDataLookup(ENTITYNAME.LiveEventRound, { sort: { SID: 1 } });
        const loadedRounds = roundRes?.data ?? [];
        setRounds(loadedRounds);

        const matchTypeRes = await API.getDataLookup(ENTITYNAME.MatchType, { sort: { SID: 1 } });
        const loadedMatchTypes = matchTypeRes?.data ?? [];
        setMatchTypes(loadedMatchTypes);

        const tournamentRes = await API.getDataLookup(ENTITYNAME.Tournament, { sort: { SID: 1 } });
        const loadedTournaments = tournamentRes?.data ?? [];
        setTournaments(loadedTournaments);

        if (items && items.length > 0) {
            const initialRows = items.map((item) => {
                const detail = item.mediaepisodedetailliveevent || {};
                const startDt = detail.StartDateTime ? new Date(detail.StartDateTime) : new Date();

                const rawMatchType = detail.MatchType || detail.matchType || item.MatchType || item.matchType;
                let matchTypeObj = null;
                if (rawMatchType) {
                    if (typeof rawMatchType === 'object') {
                        matchTypeObj = loadedMatchTypes.find((m) =>
                            (rawMatchType._id && m._id === rawMatchType._id) ||
                            (rawMatchType.SID && m.SID === rawMatchType.SID) ||
                            (rawMatchType.Description && m.Description?.toLowerCase() === rawMatchType.Description.toLowerCase())
                        ) || rawMatchType;
                    } else if (typeof rawMatchType === 'string') {
                        matchTypeObj = loadedMatchTypes.find((m) =>
                            m._id === rawMatchType ||
                            m.Description?.toLowerCase() === rawMatchType.toLowerCase()
                        ) || { Description: rawMatchType };
                    }
                }

                const rawRound = detail.Round || detail.round || item.Round || item.round;
                let roundObj = null;
                if (rawRound) {
                    if (typeof rawRound === 'object') {
                        roundObj = loadedRounds.find((r) =>
                            (rawRound._id && r._id === rawRound._id) ||
                            (rawRound.SID && r.SID === rawRound.SID) ||
                            (rawRound.Description && r.Description?.toLowerCase() === rawRound.Description.toLowerCase())
                        ) || rawRound;
                    } else if (typeof rawRound === 'string') {
                        roundObj = loadedRounds.find((r) =>
                            r._id === rawRound ||
                            r.Description?.toLowerCase() === rawRound.toLowerCase()
                        ) || { Description: rawRound };
                    }
                }

                return {
                    rawItem: item,
                    _id: item._id,
                    MediaEpisode_id: item._id,
                    MediaEpisode_SID: item.SID ?? 0,
                    mediaEpisodeDetailId: detail._id,
                    AssetId: item.AssetId || "",
                    Title: item.Title || "",
                    StartDate: moment(startDt).utc().format("YYYY-MM-DD"),
                    StartTime: moment(startDt).utc().format("HH:mm:ss:SS"),
                    Duration: item.Duration ? utility.convertMilisecondsToStringWithFrames(item.Duration) : "02:00:00:00",
                    TeamA: detail.TeamA || "",
                    TeamB: detail.TeamB || "",
                    Round: roundObj,
                    MatchType: matchTypeObj,
                    Tournament_id: detail.Tournament_id || "",
                    Venue: detail.Venue || "",
                };
            });
            setRows(initialRows);
        }
    };

    const handleChange = (id, field, value) => {
        setRows((prevRows) =>
            prevRows.map((row) => (row._id === id ? { ...row, [field]: value } : row))
        );
    };

    const handleSave = async () => {
        setIsSaving(true);
        try {
            for (const row of rows) {
                const rawItem = row.rawItem || {};
                const rawDetail = rawItem.mediaepisodedetailliveevent || {};

                const mediaEpisodePayload = {
                    ...rawItem,
                    _id: row.MediaEpisode_id,
                    SID: row.MediaEpisode_SID,
                    Title: row.Title,
                    AssetId: row.AssetId,
                    ReleaseDate: utility.getLocalDateTimeToUtcMiliseconds(new Date(row.StartDate)),
                    Duration: utility.convertStringWithFramesToMilliseconds(row.Duration),
                    IsLive: true,
                };
                delete mediaEpisodePayload.mediaepisodedetailliveevent;
                delete mediaEpisodePayload.selected;

                await API.saveData(ENTITYNAME.MediaEpisode, mediaEpisodePayload);

                let matchTypeToSave = {};
                if (row.MatchType && typeof row.MatchType === 'object') {
                    matchTypeToSave = {
                        _id: row.MatchType._id,
                        SID: row.MatchType.SID ?? 0,
                        Description: row.MatchType.Description ?? "",
                    };
                }

                let roundToSave = {};
                if (row.Round && typeof row.Round === 'object') {
                    roundToSave = {
                        _id: row.Round._id,
                        SID: row.Round.SID ?? 0,
                        Description: row.Round.Description ?? "",
                    };
                }

                const startDateTime = utility.getLocalDateTimeToUtcMiliseconds(
                    new Date(`${row.StartDate} ${row.StartTime}`)
                );
                const detailPayload = {
                    ...rawDetail,
                    _id: row.mediaEpisodeDetailId,
                    MediaEpisode_id: row.MediaEpisode_id,
                    Tournament_id: row.Tournament_id,
                    TeamA: row.TeamA,
                    TeamB: row.TeamB,
                    StartDateTime: startDateTime,
                    Duration: utility.convertStringWithFramesToMilliseconds(row.Duration),
                    Round: roundToSave,
                    MatchType: matchTypeToSave,
                    Venue: row.Venue,
                };
                delete detailPayload.selected;

                await API.saveData(ENTITYNAME.MediaEpisodeDetailLiveEvent, detailPayload);
            }
            ToastNotification({
                type: TOAST_TYPES.SUCCESS,
                title: "Success",
                message: "Selected matches updated successfully!",
            });
            onSaveSuccess();
            onClose();
        } catch (error) {
            ToastNotification({
                type: TOAST_TYPES.ERROR,
                title: "Error",
                message: "Failed to update selected matches.",
            });
        } finally {
            setIsSaving(false);
        }
    };

    const TextInputCell = (cellProps) => (
        <td>
            <input
                type="text"
                className="form-control form-control-sm"
                value={cellProps.dataItem[cellProps.field] || ""}
                onChange={(e) => handleChange(cellProps.dataItem._id, cellProps.field, e.target.value)}
            />
        </td>
    );

    const DateCell = (cellProps) => (
        <td>
            <input
                type="date"
                className="form-control form-control-sm"
                value={cellProps.dataItem.StartDate || ""}
                onChange={(e) => handleChange(cellProps.dataItem._id, "StartDate", e.target.value)}
            />
        </td>
    );

    const TimeCell = (cellProps) => (
        <td>
            <TimePickerWithFormat
                className="form-control form-control-sm"
                name="StartTime"
                value={cellProps.dataItem.StartTime || "00:00:00:00"}
                onChange={(e) => handleChange(cellProps.dataItem._id, "StartTime", e.target.value)}
            />
        </td>
    );

    const RoundCell = (cellProps) => {
        const selectedRound = rounds.find((r) => r._id === cellProps.dataItem.Round?._id) || cellProps.dataItem.Round || null;
        return (
            <td>
                <DropDownList
                    data={rounds}
                    textField="Description"
                    dataItemKey="_id"
                    value={selectedRound}
                    onChange={(e) => handleChange(cellProps.dataItem._id, "Round", e.target.value)}
                    style={{ width: "100%" }}
                />
            </td>
        );
    };

    const MatchTypeCell = (cellProps) => {
        const selectedMatchType = matchTypes.find((m) => m._id === cellProps.dataItem.MatchType?._id) || cellProps.dataItem.MatchType || null;
        return (
            <td>
                <DropDownList
                    data={matchTypes}
                    textField="Description"
                    dataItemKey="_id"
                    value={selectedMatchType}
                    onChange={(e) => handleChange(cellProps.dataItem._id, "MatchType", e.target.value)}
                    style={{ width: "100%" }}
                />
            </td>
        );
    };

    const TournamentCell = (cellProps) => {
        const selectedTournament = tournaments.find((t) => t._id === cellProps.dataItem.Tournament_id) || null;
        return (
            <td>
                <DropDownList
                    data={tournaments}
                    textField="Name"
                    dataItemKey="_id"
                    value={selectedTournament}
                    onChange={(e) => handleChange(cellProps.dataItem._id, "Tournament_id", e.target.value?._id)}
                    style={{ width: "100%" }}
                />
            </td>
        );
    };

    if (!open) return null;

    return (
        <BossDialog title="Edit Selected Live Events" onClose={onClose} width="90vw">
            <div className="mb-3 d-flex justify-content-end" style={{ gap: "10px" }}>
                <SaveButton onClick={handleSave} disabled={isSaving} />
                <CancelButton onClick={onClose} disabled={isSaving} />
            </div>
            <Grid data={rows} style={{ maxHeight: "65vh" }}>
                <Column field="AssetId" title="Asset ID" cell={TextInputCell} width="140px" />
                <Column field="Title" title="Title" cell={TextInputCell} width="180px" />
                <Column field="StartDate" title="Start Date" cell={DateCell} width="150px" />
                <Column field="StartTime" title="Start Time" cell={TimeCell} width="150px" />
                <Column field="Duration" title="Duration" cell={TextInputCell} width="140px" />
                <Column field="TeamA" title="Team A" cell={TextInputCell} width="140px" />
                <Column field="TeamB" title="Team B" cell={TextInputCell} width="140px" />
                <Column field="Round" title="Round" cell={RoundCell} width="160px" />
                <Column field="MatchType" title="Match Type" cell={MatchTypeCell} width="160px" />
                <Column field="Tournament_id" title="Tournament" cell={TournamentCell} width="180px" />
                <Column field="Venue" title="Venue" cell={TextInputCell} width="150px" />
            </Grid>
        </BossDialog>
    );
};
